// src/useClickOutside/useClickOutside.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useCallback, useEffect, useRef } from "react";
function useClickOutside(ref, callback) {
    var detectEscape = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    for(var _len = arguments.length, include = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
        include[_key - 3] = arguments[_key];
    }
    var callbackRef = useRef(callback);
    useEffect(function() {
        callbackRef.current = callback;
    }, [
        callback
    ]);
    var handleMouseDown = useCallback(function(evt) {
        if (!ref.current) return;
        var clicked = evt.target;
        if (ref.current.contains(clicked)) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = include[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var other = _step.value;
                if (!other.current) continue;
                if (other.current.contains(clicked)) return;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        callbackRef.current(evt);
    }, [
        ref,
        include
    ]);
    var handleKeyDown = useCallback(function(evt) {
        if (!detectEscape || !_instanceof(evt, KeyboardEvent) || evt.key !== "Escape") return;
        callbackRef.current(evt);
    }, [
        detectEscape
    ]);
    useEffect(function() {
        document.addEventListener("mousedown", handleMouseDown);
        document.addEventListener("touchstart", handleMouseDown);
        if (detectEscape) document.addEventListener("keydown", handleKeyDown);
        return function() {
            document.removeEventListener("mousedown", handleMouseDown);
            document.removeEventListener("touchstart", handleMouseDown);
            if (detectEscape) document.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        detectEscape,
        handleMouseDown,
        handleKeyDown
    ]);
}
// src/useDebounce/useDebounce.ts
import { useEffect as useEffect2, useState } from "react";
function useDebounce(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 350;
    var _useState = _sliced_to_array(useState(value), 2), debouncedValue = _useState[0], setDebouncedValue = _useState[1];
    useEffect2(function() {
        var timeout = setTimeout(function() {
            return setDebouncedValue(value);
        }, delay);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
// src/useForm/useForm.ts
import isEqual from "lodash/isEqual";
import merge from "lodash/merge";
import pick from "lodash/pick";
import { useCallback as useCallback2, useEffect as useEffect3, useMemo, useRef as useRef2, useState as useState2 } from "react";
// src/useForm/util.ts
var LS_DEFAULT_FORM_STATE_KEY = "use-form-values";
function tryParseJson(inp) {
    try {
        var obj = JSON.parse(inp);
        return obj;
    } catch (e) {
        return null;
    }
}
function getDefaultFormName() {
    return window.location.pathname;
}
function getStorage(storageConfig) {
    return !!storageConfig.sessionStorage ? window.sessionStorage : window.localStorage;
}
function retrieveFormState(reference, storageConfig) {
    var storage = getStorage(storageConfig);
    var _storageConfig_storeFormStateKey;
    var lsKey = (_storageConfig_storeFormStateKey = storageConfig.storeFormStateKey) !== null && _storageConfig_storeFormStateKey !== void 0 ? _storageConfig_storeFormStateKey : LS_DEFAULT_FORM_STATE_KEY;
    var _storageConfig_storeFormStateName;
    var name = (_storageConfig_storeFormStateName = storageConfig.storeFormStateName) !== null && _storageConfig_storeFormStateName !== void 0 ? _storageConfig_storeFormStateName : getDefaultFormName();
    var item = storage.getItem(lsKey);
    if (item === null) return null;
    var parsed = tryParseJson(item);
    if (parsed === null) return null;
    var state = parsed[name];
    if (typeof state === "undefined") return null;
    var retrievedKeys = Object.keys(state);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = retrievedKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!reference.hasOwnProperty(key)) return null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var transforms = storageConfig.transformValues;
    if (typeof transforms !== "undefined") {
        var transformedState = Object.entries(state).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            if (transforms.hasOwnProperty(key) && typeof transforms[key] !== "undefined") {
                var _transforms_key;
                var transformed = (_transforms_key = transforms[key]) === null || _transforms_key === void 0 ? void 0 : _transforms_key.call(transforms, value);
                acc[key] = transformed !== null && transformed !== void 0 ? transformed : reference[key];
            }
            return acc;
        }, reference);
        state = _object_spread({}, state, transformedState);
    }
    return state;
}
function storeFormState(values, storageConfig) {
    var storage = getStorage(storageConfig);
    var _storageConfig_storeFormStateKey;
    var lsKey = (_storageConfig_storeFormStateKey = storageConfig.storeFormStateKey) !== null && _storageConfig_storeFormStateKey !== void 0 ? _storageConfig_storeFormStateKey : LS_DEFAULT_FORM_STATE_KEY;
    var _storageConfig_storeFormStateName;
    var name = (_storageConfig_storeFormStateName = storageConfig.storeFormStateName) !== null && _storageConfig_storeFormStateName !== void 0 ? _storageConfig_storeFormStateName : getDefaultFormName();
    var lsItem = storage.getItem(lsKey);
    var _tryParseJson;
    var data = lsItem === null ? {} : (_tryParseJson = tryParseJson(lsItem)) !== null && _tryParseJson !== void 0 ? _tryParseJson : {};
    var _storageConfig_excludeFields;
    var exclude = (_storageConfig_excludeFields = storageConfig.excludeFields) !== null && _storageConfig_excludeFields !== void 0 ? _storageConfig_excludeFields : [];
    var doParse = exclude.length > 0;
    var parsedValues = !doParse ? values : Object.entries(values).reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (!exclude.includes(key)) acc[key] = value;
        return acc;
    }, {});
    data[name] = parsedValues;
    storage.setItem(lsKey, JSON.stringify(data));
}
function clearFormState(storageConfig) {
    var storage = getStorage(storageConfig);
    var _storageConfig_storeFormStateKey;
    var lsKey = (_storageConfig_storeFormStateKey = storageConfig.storeFormStateKey) !== null && _storageConfig_storeFormStateKey !== void 0 ? _storageConfig_storeFormStateKey : LS_DEFAULT_FORM_STATE_KEY;
    var _storageConfig_storeFormStateName;
    var name = (_storageConfig_storeFormStateName = storageConfig.storeFormStateName) !== null && _storageConfig_storeFormStateName !== void 0 ? _storageConfig_storeFormStateName : getDefaultFormName();
    var lsItem = storage.getItem(lsKey);
    if (lsItem === null) return;
    var _tryParseJson;
    var data = lsItem === null ? {} : (_tryParseJson = tryParseJson(lsItem)) !== null && _tryParseJson !== void 0 ? _tryParseJson : {};
    if (name in data) delete data[name];
    storage.setItem(lsKey, JSON.stringify(data));
}
function isKeyofTArray(arg) {
    return Array.isArray(arg) && arg.every(function(i) {
        return typeof i === "string";
    });
}
// src/useForm/useForm.ts
function useForm(options) {
    var defaultConfig = useMemo(function() {
        return {
            callbacks: {},
            storage: {
                storeFormState: false,
                storeFormStateName: null,
                storeFormStateKey: null,
                retrieveFormStateOnMount: false,
                retrieveFormStatePrompt: "An unsubmitted version of this form was found. Do you wish to restore it?",
                excludeFields: [],
                sessionStorage: false
            },
            realtimeValidation: true,
            onlyValidateAfterFirstUpdate: true,
            initAsInvalid: false,
            validateImmediately: false,
            disableValidationInitially: false,
            dontUpdateFormValidForDisabled: false,
            onFormChange: function() {
                return void 0;
            }
        };
    }, []);
    var overloadedConfig = useMemo(function() {
        return merge(defaultConfig, options.config);
    }, [
        defaultConfig,
        options.config
    ]);
    var hasCallbacks = Object.keys(overloadedConfig.callbacks).length > 0;
    var overloadedOptions = useMemo(function() {
        return _object_spread_props(_object_spread({
            validators: {}
        }, options), {
            config: overloadedConfig
        });
    }, [
        options,
        overloadedConfig
    ]);
    var firstMount = useRef2(true);
    var initialValues = useRef2(overloadedOptions.values);
    var initialEdited = Object.keys(overloadedOptions.values).reduce(function(acc, key) {
        acc[key] = false;
        return acc;
    }, {});
    var beenEdited = useRef2(initialEdited);
    var disabledValidation = useRef2(Object.keys(overloadedOptions.values).reduce(function(acc, key) {
        acc[key] = !overloadedOptions.config.disableValidationInitially ? false : overloadedOptions.config.disableValidationInitially === true ? true : overloadedOptions.config.disableValidationInitially.includes(key);
        return acc;
    }, {}));
    var _useState2 = _sliced_to_array(useState2(overloadedOptions.values), 2), formValues = _useState2[0], setFormValues = _useState2[1];
    var _useState21 = _sliced_to_array(useState2(function() {
        return Object.keys(overloadedOptions.values).reduce(function(acc, key) {
            acc[key] = null;
            return acc;
        }, {});
    }), 2), formErrors = _useState21[0], setFormErrors = _useState21[1];
    var _useState22 = _sliced_to_array(useState2(!overloadedConfig.initAsInvalid), 2), formValid = _useState22[0], setFormValid = _useState22[1];
    var _useState23 = _sliced_to_array(useState2(function() {
        return Object.keys(overloadedOptions.values).reduce(function(acc, key) {
            acc[key] = false;
            return acc;
        }, {});
    }), 2), formValuesEdited = _useState23[0], setFormValuesEdited = _useState23[1];
    var _useState24 = _sliced_to_array(useState2(false), 2), formEdited = _useState24[0], setFormEdited = _useState24[1];
    var validateForm = useCallback2(function(values) {
        var updateFormErrors2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, updateFormValid = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, alternativeFormValues = arguments.length > 3 ? arguments[3] : void 0;
        var internalValues = {};
        if (typeof values === "undefined") internalValues = formValues;
        else if (isKeyofTArray(values)) internalValues = pick(formValues, values);
        else internalValues = values;
        var internalFormValues = _object_spread({}, formValues, alternativeFormValues);
        var validators = overloadedOptions.validators;
        var disabledValidators = disabledValidation.current;
        var skipValidForDisabled = overloadedConfig.dontUpdateFormValidForDisabled;
        var newErrors = _object_spread({}, formErrors);
        var valid = true;
        var valueEntries = Object.entries(_object_spread({}, formValues, internalValues));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = valueEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                var validator = validators[key];
                var disabled = disabledValidators[key];
                var included = typeof internalValues[key] !== "undefined";
                if (disabled) newErrors[key] = null;
                if (!validator || skipValidForDisabled && disabled) continue;
                var currentValid = true;
                if (Array.isArray(validator)) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = validator[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var val = _step1.value;
                            var result = val(value, internalFormValues);
                            !disabled && included && (newErrors[key] = result);
                            currentValid = currentValid && result === null;
                            if (result !== null) break;
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                } else {
                    var result1 = validator(value, internalFormValues);
                    !disabled && included && (newErrors[key] = result1);
                    currentValid = currentValid && result1 === null;
                }
                valid = valid && currentValid;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (updateFormErrors2) setFormErrors(newErrors);
        if (updateFormValid) setFormValid(valid);
        return {
            errors: newErrors,
            valid: valid
        };
    }, [
        formErrors,
        formValues,
        overloadedConfig,
        overloadedOptions
    ]);
    var updateFormErrors = useCallback2(function(errors) {
        var updateValid = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var newErrors = _object_spread({}, formErrors, errors);
        setFormErrors(function() {
            return newErrors;
        });
        if (updateValid) {
            var valid = !Object.values(newErrors).some(function(v) {
                return v !== null;
            });
            if (!valid) setFormValid(valid);
            else validateForm(void 0, false);
        }
    }, [
        formErrors,
        validateForm
    ]);
    var updateInitialValues = useCallback2(function(values) {
        var newInitialValues = _object_spread({}, formValues, values);
        initialValues.current = newInitialValues;
        Object.keys(newInitialValues).forEach(function(name) {
            return beenEdited.current[name] = false;
        });
        setFormEdited(false);
        setFormValuesEdited(beenEdited.current);
    }, [
        formValues
    ]);
    var updateForm = useCallback2(function(values) {
        var options2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        options2 = _object_spread({
            runCallbacks: true
        }, options2);
        var updatedValues = _object_spread({}, formValues, values);
        Object.keys(values).forEach(function(name) {
            return beenEdited.current[name] = true;
        });
        var editedValues = Object.entries(updatedValues).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), name = _param[0], value = _param[1];
            var initialValue = initialValues.current[name];
            acc[name] = !isEqual(value, initialValue);
            return acc;
        }, {});
        setFormValuesEdited(editedValues);
        setFormEdited(Object.values(editedValues).some(function(v) {
            return v;
        }));
        setFormValues(updatedValues);
        overloadedConfig.onFormChange(updatedValues);
        if (options2.runCallbacks && hasCallbacks) {
            var _overloadedConfig_callbacks_key, _overloadedConfig_callbacks;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = _sliced_to_array(_step.value, 2), key = _step_value[0], value = _step_value[1];
                    if (typeof value !== "undefined") (_overloadedConfig_callbacks_key = (_overloadedConfig_callbacks = overloadedConfig.callbacks)[key]) === null || _overloadedConfig_callbacks_key === void 0 ? void 0 : _overloadedConfig_callbacks_key.call(_overloadedConfig_callbacks, value, updatedValues);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        if (options2.storeFormState === true || overloadedConfig.storage.storeFormState && options2.storeFormState !== false) storeFormState(updatedValues, overloadedConfig.storage);
        var updatedValuesForValidation = updatedValues;
        if (typeof options2.includeValidation !== "undefined") {
            for(var key1 in options2.includeValidation){
                var _updatedValuesForValidation_key;
                var value1 = (_updatedValuesForValidation_key = updatedValuesForValidation[key1]) !== null && _updatedValuesForValidation_key !== void 0 ? _updatedValuesForValidation_key : formValues[key1];
                updatedValuesForValidation = _object_spread_props(_object_spread({}, updatedValuesForValidation), _define_property({}, key1, value1));
            }
        }
        if (options2.runValidation === true || overloadedConfig.realtimeValidation && options2.runValidation !== false) if (overloadedConfig.onlyValidateAfterFirstUpdate) {
            var valuesToValidate = Object.entries(updatedValuesForValidation).reduce(function(acc, param) {
                var _param = _sliced_to_array(param, 2), name = _param[0], value = _param[1];
                var isEdited = beenEdited.current[name];
                if (isEdited) acc[name] = value;
                return acc;
            }, {});
            validateForm(valuesToValidate, true, true, updatedValues);
        } else validateForm(updatedValuesForValidation, true, true, updatedValues);
        if (options2.updateInitialValues === true) updateInitialValues(updatedValues);
    }, [
        formValues,
        hasCallbacks,
        overloadedConfig,
        updateInitialValues,
        validateForm
    ]);
    var formChangeHandler = useCallback2(function(key, options2) {
        return function(value) {
            return updateForm(_define_property({}, key, value), options2);
        };
    }, [
        updateForm
    ]);
    var resetForm = useCallback2(function() {
        var values = initialValues.current;
        setFormValues(values);
        setFormErrors(function() {
            return Object.keys(values).reduce(function(acc, key) {
                acc[key] = null;
                return acc;
            }, {});
        });
        setFormValid(!overloadedConfig.initAsInvalid);
        var valuesEdited = Object.keys(values).reduce(function(acc, key) {
            acc[key] = false;
            return acc;
        }, {});
        beenEdited.current = valuesEdited;
        setFormValuesEdited(valuesEdited);
        setFormEdited(false);
    }, [
        overloadedConfig.initAsInvalid
    ]);
    var loadStoredFormState = useCallback2(function() {
        var insert = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var retrieved = retrieveFormState(overloadedOptions.values, overloadedConfig.storage);
        if (retrieved === null) return null;
        if (insert) updateForm(retrieved, {
            runCallbacks: false
        });
        return retrieved;
    }, [
        overloadedOptions.values,
        overloadedConfig.storage,
        updateForm
    ]);
    var clearStoredFormState = useCallback2(function() {
        clearFormState(overloadedConfig.storage);
    }, [
        overloadedConfig.storage
    ]);
    var enableValidation = useCallback2(function(key) {
        var run = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, enable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (!enable === disabledValidation.current[key]) return;
        disabledValidation.current = _object_spread_props(_object_spread({}, disabledValidation.current), _define_property({}, key, !enable));
        if (run) validateForm([
            key
        ]);
    }, [
        validateForm
    ]);
    var submitHandler = useCallback2(function(handler) {
        var errorHandler = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
            return void 0;
        };
        return function() {
            var _validateForm = validateForm(), valid = _validateForm.valid, errors = _validateForm.errors;
            if (valid) {
                handler(formValues);
                clearStoredFormState();
            } else errorHandler(errors);
        };
    }, [
        formValues,
        clearStoredFormState,
        validateForm
    ]);
    useEffect3(function() {
        if (!firstMount.current) return;
        firstMount.current = false;
        if (overloadedConfig.validateImmediately) validateForm();
        if (!overloadedConfig.storage.storeFormState || !overloadedConfig.storage.retrieveFormStateOnMount) return;
        var retrieved = loadStoredFormState(false);
        if (retrieved === null) return;
        if (overloadedConfig.storage.retrieveFormStateOnMount === "ask") {
            if (!window.confirm(overloadedConfig.storage.retrieveFormStatePrompt)) return;
        }
        updateForm(retrieved, {
            runCallbacks: false
        });
    }, [
        overloadedConfig.storage.storeFormState,
        overloadedConfig.storage.storeFormStateName,
        overloadedConfig.storage.storeFormStateKey,
        overloadedConfig.storage.retrieveFormStateOnMount,
        overloadedConfig.storage.retrieveFormStatePrompt,
        overloadedConfig.validateImmediately,
        overloadedOptions.values,
        updateForm,
        loadStoredFormState,
        validateForm,
        formValues
    ]);
    return {
        formValues: formValues,
        formErrors: formErrors,
        formValid: formValid,
        formEdited: formEdited,
        formValuesEdited: formValuesEdited,
        updateForm: updateForm,
        validateForm: validateForm,
        resetForm: resetForm,
        updateFormErrors: updateFormErrors,
        updateInitialValues: updateInitialValues,
        formChangeHandler: formChangeHandler,
        loadStoredFormState: loadStoredFormState,
        clearStoredFormState: clearStoredFormState,
        enableValidation: enableValidation,
        submitHandler: submitHandler
    };
}
// src/useGlobal/useGlobal.tsx
import get from "lodash/get";
import omit from "lodash/omit";
import set from "lodash/set";
import uniqueId from "lodash/uniqueId";
import React2, { useCallback as useCallback3, useContext, useEffect as useEffect4, useMemo as useMemo2, useRef as useRef3, useState as useState3 } from "react";
import { jsx } from "react/jsx-runtime";
var GlobalContext = React2.createContext(null);
function getValue(obj, path) {
    return get(obj, path);
}
function setValue(obj, path, value) {
    set(obj, path, value);
}
function useGlobal(path) {
    var ctx = useContext(GlobalContext);
    if (ctx === null) throw new Error("useGlobal can only be used within a GlobalProvider.");
    var myId = useRef3(uniqueId("globalStoreListener"));
    var stored = useMemo2(function() {
        return getValue(ctx.store, path);
    }, [
        ctx.store,
        path
    ]);
    var _useState3 = _sliced_to_array(useState3(stored), 2), current = _useState3[0], setCurrent = _useState3[1];
    useEffect4(function() {
        var id = myId.current;
        var register = ctx.register, unregister = ctx.unregister;
        register(id, function() {
            var value = getValue(ctx.store, path);
            setCurrent(value);
        });
        return function() {
            return unregister(id);
        };
    }, [
        ctx,
        path
    ]);
    var setter = useCallback3(function(value) {
        var newValue = typeof value === "function" ? value(current) : value;
        setValue(ctx.store, path, newValue);
        ctx.ping();
    }, [
        ctx,
        path,
        current
    ]);
    return [
        current,
        setter
    ];
}
var UseGlobalProvider = function(param) {
    var children = param.children, store = param.store;
    var listeners = useRef3({});
    var register = useCallback3(function(id, callback) {
        listeners.current = _object_spread_props(_object_spread({}, listeners.current), _define_property({}, id, callback));
    }, []);
    var unregister = useCallback3(function(id) {
        listeners.current = omit(listeners.current, id);
    }, []);
    var ping = useCallback3(function() {
        Object.values(listeners.current).forEach(function(callback) {
            return callback();
        });
    }, []);
    return /* @__PURE__ */ jsx(GlobalContext.Provider, {
        value: {
            store: store,
            register: register,
            unregister: unregister,
            ping: ping
        },
        children: children
    });
};
// src/useSleep/useSleep.ts
import { useRef as useRef4, useEffect as useEffect5 } from "react";
function useSleep() {
    var timerRef = useRef4([]);
    useEffect5(function() {
        return function() {
            return timerRef.current.forEach(clearTimeout);
        };
    }, []);
    return function(ms) {
        return new Promise(function(done) {
            timerRef.current.push(window.setTimeout(done, ms));
        });
    };
}
// src/useSound/useSound.ts
import { useCallback as useCallback4 } from "react";
function useSound(soundFile) {
    var play = useCallback4(function() {
        var audio = new Audio(soundFile);
        audio.play();
    }, [
        soundFile
    ]);
    return play;
}
// src/useTranslate/useTranslate.ts
import isEqual2 from "lodash/isEqual";
import { useCallback as useCallback5, useEffect as useEffect6, useRef as useRef5, useState as useState4 } from "react";
import { useIntl } from "react-intl";
// src/util/typechecks.ts
function isFunction(arg) {
    return typeof arg === "function";
}
function isString(arg) {
    return typeof arg === "string";
}
function isArray(arg) {
    return Array.isArray(arg);
}
function isStringArray(arg) {
    return isArray(arg) && arg.every(function(a) {
        return typeof a === "string";
    });
}
// src/useTranslate/useTranslate.ts
function useTranslate(messages) {
    var key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "lesmiserables";
    var intl = useIntl();
    var keyRef = useRef5(key);
    var localeRef = useRef5(intl.locale);
    var translateMessageId = useCallback5(function(id) {
        return intl.formatMessage({
            id: id
        });
    }, [
        intl
    ]);
    var translateMessageIdWithDefault = useCallback5(function(param) {
        var _param = _sliced_to_array(param, 2), id = _param[0], defaultMessage = _param[1];
        return intl.formatMessage({
            id: id,
            defaultMessage: defaultMessage
        });
    }, [
        intl
    ]);
    var translateMessageIdWithCallback = useCallback5(function(param) {
        var _param = _sliced_to_array(param, 2), id = _param[0], values = _param[1];
        return function(args) {
            return intl.formatMessage({
                id: id
            }, _object_spread({}, values, args));
        };
    }, [
        intl
    ]);
    var translateMessageIdWithCallbackAndTransformer = useCallback5(function(param) {
        var _param = _sliced_to_array(param, 3), id = _param[0], values = _param[1], transformer = _param[2];
        return function(args) {
            return transformer(translateMessageIdWithCallback([
                id,
                values
            ])(args));
        };
    }, [
        translateMessageIdWithCallback
    ]);
    var runTranslation = useCallback5(function(msgs) {
        var toTranslate = msgs !== null && msgs !== void 0 ? msgs : messages;
        return Object.entries(toTranslate).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key2 = _param[0], value = _param[1];
            if (isStringArray(value)) acc[key2] = translateMessageIdWithDefault(value);
            else if (isArray(value)) if (isFunction(value[1])) acc[key2] = value[1](translateMessageId(value[0]));
            else if (value.length === 3) acc[key2] = translateMessageIdWithCallbackAndTransformer(value);
            else acc[key2] = translateMessageIdWithCallback(value);
            else if (isString(value)) acc[key2] = translateMessageId(value);
            else acc[key2] = runTranslation(value);
            return acc;
        }, {});
    }, [
        messages,
        translateMessageId,
        translateMessageIdWithCallback,
        translateMessageIdWithCallbackAndTransformer,
        translateMessageIdWithDefault
    ]);
    var _useState4 = _sliced_to_array(useState4(function() {
        return runTranslation();
    }), 2), translated = _useState4[0], setTranslated = _useState4[1];
    useEffect6(function() {
        if (localeRef.current === intl.locale && isEqual2(keyRef.current, key)) return;
        localeRef.current = intl.locale;
        keyRef.current = key;
        var trans = runTranslation();
        setTranslated(trans);
    }, [
        intl.locale,
        key,
        runTranslation
    ]);
    return translated;
}
// src/useTranslate/UseTranslateProvider.tsx
import { useMemo as useMemo4 } from "react";
import { IntlProvider } from "react-intl";
// src/useTranslate/useLocale.tsx
import React3, { useCallback as useCallback6, useContext as useContext2, useMemo as useMemo3, useState as useState5 } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var LocaleContext = React3.createContext(null);
function useLocale() {
    var locale = useContext2(LocaleContext);
    if (locale === null) throw new Error("No locale provider found. Wrap your app in a <UseTranslateProvider>.");
    return locale;
}
var LocaleProvider = function(param) {
    var children = param.children, initialLocale = param.initialLocale, availableLocales = param.availableLocales, onLocaleChange = param.onLocaleChange;
    var _useState5 = _sliced_to_array(useState5(initialLocale), 2), localLocale = _useState5[0], setLocalLocale = _useState5[1];
    var handleSetLocale = useCallback6(function(locale) {
        var newLocale = typeof locale === "function" ? locale(localLocale) : locale;
        setLocalLocale(newLocale);
        onLocaleChange === null || onLocaleChange === void 0 ? void 0 : onLocaleChange(newLocale);
    }, [
        localLocale,
        onLocaleChange
    ]);
    var value = useMemo3(function() {
        return {
            locale: localLocale,
            setLocale: handleSetLocale,
            availableLocales: availableLocales
        };
    }, [
        localLocale,
        handleSetLocale,
        availableLocales
    ]);
    return /* @__PURE__ */ jsx2(LocaleContext.Provider, {
        value: value,
        children: children
    });
};
// src/useTranslate/UseTranslateProvider.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var InnerProvider = function(_param) {
    var children = _param.children, messages = _param.messages, props = _object_without_properties(_param, [
        "children",
        "messages"
    ]);
    var locale = useLocale().locale;
    var localeMessages = useMemo4(function() {
        if (!(locale in messages)) throw new Error("UseTranslateProvider: messages does not contain locale ".concat(locale));
        return messages[locale];
    }, [
        locale,
        messages
    ]);
    return /* @__PURE__ */ jsx3(IntlProvider, _object_spread_props(_object_spread({}, props), {
        locale: locale,
        messages: localeMessages,
        children: children
    }));
};
var UseTranslateProvider = function(_param) {
    var children = _param.children, initialLocale = _param.initialLocale, messages = _param.messages, onLocaleChange = _param.onLocaleChange, intlConfig = _object_without_properties(_param, [
        "children",
        "initialLocale",
        "messages",
        "onLocaleChange"
    ]);
    var availableLocales = useMemo4(function() {
        return Object.keys(messages);
    }, [
        messages
    ]);
    return /* @__PURE__ */ jsx3(LocaleProvider, {
        initialLocale: initialLocale,
        availableLocales: availableLocales,
        onLocaleChange: onLocaleChange,
        children: /* @__PURE__ */ jsx3(InnerProvider, _object_spread_props(_object_spread({}, intlConfig), {
            messages: messages,
            children: children
        }))
    });
};
// src/useTranslate/index.ts
import { useIntl as useIntl2 } from "react-intl";
export { UseGlobalProvider, UseTranslateProvider, useClickOutside, useDebounce, useForm, useGlobal, useIntl2 as useIntl, useLocale, useSleep, useSound, useTranslate };
